import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
/* Self-hosted faces, imported before tokens so the @font-face rules exist by the
 * time anything measures text. Only the weights the system actually uses — a
 * board on an internal host should not ship nine unused files. 300 carries the
 * large figures: a big number at 400 reads as shouting, and an instrument sets
 * it light and lets size do the work. */
import '@fontsource/fira-sans/300.css'
import '@fontsource/fira-sans/400.css'
import '@fontsource/fira-sans/500.css'
import '@fontsource/fira-sans/600.css'
import '@fontsource/fira-mono/400.css'
import '@fontsource/fira-mono/500.css'
import './tokens.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A wall board is left open for hours. Refetching on focus would produce a
      // burst of requests every time someone walks past and clicks the window.
      refetchOnWindowFocus: false,
      staleTime: 5_000,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
